import React from "react";
import { ReactElement } from "react";
import * as DashboardStore from '../../store/DashboardStore';
import { connect } from 'react-redux';
import { LoggedInUser, UserRole } from "../../models/LoggedInUser";
import { PolicyInfo } from "../../models/PolicyInfo";
import CutoverComingSoon from "./CutoverComingSoon";
import CutoverAddressCollection from "./CutoverAddressCollection";
import CutoverSuccess from "./CutoverSuccess";

interface CutoverPageProps {
    loggedInUser: LoggedInUser;
    policy: PolicyInfo;
    eligibleProgram: any;
}

interface CutoverPageState {
    policy: PolicyInfo,
    eligibleProgram: any,
    selectedOption: string
}


export class CutoverPage extends React.Component<any, CutoverPageState> {
    constructor(props: CutoverPageProps) {
        super(props);
        this.state = {
            policy: this.props.policy,
            eligibleProgram: this.props.eligibleProgram,
            selectedOption: ""
        };
    }

    async componentDidMount(): Promise<void> {
    }

    onClickRadioButton(radioId: string): void {
        let radioButton = document.getElementById(radioId) as HTMLInputElement;

        radioButton.checked = !radioButton.checked;

        const otherRadioId = radioId === "radio1" ? "radio2" : "radio1";
        if (radioButton.checked) {
            document.getElementById("opt-in-radiogroup")?.classList.remove("form-field--error");
            (document.getElementById(otherRadioId) as HTMLInputElement).checked = false;
            this.setState({
                selectedOption: radioButton.defaultValue || ""
            });
        }
        else {
            document.getElementById("opt-in-radiogroup")?.classList.add("form-field--error");
            this.setState({
                selectedOption: ""
            });
        }
    }

    onClickAgree(): void {
        const { selectedOption } = this.state;

        let cutoverContainer = document.getElementById("cutover-container") as HTMLElement;
        let addressCollectContainer = document.getElementById("cutover-address-collection-container") as HTMLElement;

        if (selectedOption === "yes") {
            cutoverContainer.style.display = "none";
            addressCollectContainer.style.display = "block";
            window.scrollTo(0, 0);
        }
        else if (selectedOption === "maybeLater") {
            let url = "";
            if (localStorage.getItem("returnUrl")) {
                let returnUrl = localStorage.getItem("returnUrl") ?? "";
                url = encodeURIComponent(returnUrl) || "/dashboard";
            }
            window.location.href = url;
        }
        else {
            let radiogroup = document.getElementById("opt-in-radiogroup");
            radiogroup?.classList.add("form-field--error");
        }
    }

    render(): ReactElement {
        const { loggedInUser, eligibleProgram } = this.props;
        const { policy, selectedOption } = this.state;
        return (
            <>
                {eligibleProgram && eligibleProgram.programCode === "DriveEasyProOBD2" &&
                    <div className="container cutover-container" id="cutover-container">
                        <div className="row cutover-header-row">
                            <div className="col-sm-12">
                                <p className="cutover-chip chips chips-generic">New! DriveEasy Pro</p>
                            </div>
                            <div className="col-sm-12">
                                <div className="cutover-header">A new and improved DriveEasy Pro.</div>
                            </div>
                            <div className="col-sm-12">
                                <div className="cutover-subheader">Better manage your vehicles and earn personalized savings at a future renewal.</div>
                            </div>
                            <div className="col-sm-12">
                                <div className="container obd-photo-container">
                                    <img src="/images/customerObdInstallationFlutter.png" alt="OBD Device" className="obd-photo" />
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div className="cutover-subheader">Just plug in and drive! Our OBD device automatically tracks real-time vehicle locations and statuses on our free DriveEasy Pro Fleet Dashboard.</div>
                            </div>
                            <div className="col-sm-12">
                                <div className="cutover-text"><b>No more mobile tracking on the DriveEasy Pro app.</b> An On-Board Diagnostic (OBD) device is a small device that easily plugs into the OBD port inside your vehicle to track real-time GPS location and driving data. All equipment is included at no extra cost.</div>
                            </div>
                            <div className="col-sm-12">
                                <div className="row encryption-row"><div className="icon-security cutover-icon" /><div className="cutover-encryption-text">GEICO encrypts all data and will never share or sell your info.</div></div>
                            </div>
                            <div className="col-sm-12">
                                <div className="cutover-subheader cutover-table-heading">Same coverage, more benefits.</div>
                            </div>
                            <div className="col-sm-12">
                                <div className="flexible-container cutover-benefits-table">
                                    <div className="row benefit-row">
                                        <div className="col-sm-6 cutover-left-col">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header cutover-benefits-table-header"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 cutover-table-column cutover-new-benefits-column">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header cutover-benefits-table-header cutover-table-extend-cell-up">New DriveEasy Pro</div>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 cutover-table-column">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header cutover-benefits-table-header">Old DriveEasy Pro</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row benefit-row">
                                        <div className="col-sm-6 cutover-left-col">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header cutover-benefit-bold-header">Easy OBD Set Up</div>
                                                <div className="cutover-benefit-header">No more mobile setup for your drivers.</div>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 cutover-table-column cutover-new-benefits-column">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header icon-confirmation" />
                                            </div>
                                        </div>
                                        <div className="col-sm-3 cutover-table-column">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header icon-collapse" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row benefit-row">
                                        <div className="col-sm-6 cutover-left-col">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header cutover-benefit-bold-header">Real-time Location Tracking</div>
                                                <div className="cutover-benefit-header">With vehicle statuses on our free dashboard</div>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 cutover-table-column cutover-new-benefits-column">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header icon-confirmation" />
                                            </div>
                                        </div>
                                        <div className="col-sm-3 cutover-table-column">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header icon-collapse" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row benefit-row">
                                        <div className="col-sm-6 cutover-left-col cutover-col-coming-soon">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header cutover-benefit-bold-header cutover-text-coming-soon">Fleet Management Tools</div>
                                                <div className="cutover-benefit-header cutover-text-coming-soon">Vehicle health insights, driving scores & tips</div>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 cutover-table-column cutover-new-benefits-column">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header">
                                                    <p className="cutover-benefit-chip chips chips-success">Coming Soon!</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 cutover-table-column cutover-col-coming-soon">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header icon-collapse cutover-icon-coming-soon" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row benefit-row">
                                        <div className="col-sm-6 cutover-left-col cutover-col-coming-soon">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header cutover-benefit-bold-header cutover-text-coming-soon">Driving Behaviors Breakdown</div>
                                                <div className="cutover-benefit-header cutover-text-coming-soon">Speeding, hard-braking, sharp cornering</div>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 cutover-table-column cutover-new-benefits-column">
                                            <div className="cutover-table-extend-cell-down">
                                                <p className="cutover-benefit-chip chips chips-success">Coming Soon!</p>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 cutover-table-column cutover-col-coming-soon">
                                            <div className="cutover-benefit">
                                                <div className="cutover-benefit-header icon-collapse cutover-icon-coming-soon" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div className="cutover-text cutover-learn-more-link"><a href="https://www.geico.com/driveeasypro/help-center/" target="_blank">Learn more about DriveEasy Pro</a></div>
                            </div>
                            <div className="col-sm-12">
                                <form>
                                    <fieldset id="opt-in-radiogroup" role="radiogroup" className="form-field radio-button-group">
                                        <legend>Opt in to DriveEasy Pro?</legend>
                                        <div className="radio-button-wrapper col-1">
                                            <div className="radio-button" onClick={() => this.onClickRadioButton("radio1")}>
                                                <input id="radio1" type="radio" value="yes" />
                                                <label className="radio"><span>Yes</span></label>
                                            </div>
                                            <div className="radio-button" onClick={() => this.onClickRadioButton("radio2")}>
                                                <input id="radio2" type="radio" value="maybeLater" />
                                                <label className="radio"><span>Maybe Later</span></label>
                                            </div>
                                        </div>
                                    </fieldset>
                                </form>
                            </div>
                            {loggedInUser.userRole !== UserRole.Agent && selectedOption !== "maybeLater" && <div className="col-sm-12">
                                <div className="flexible-container cutover-eula-container">
                                    <div className="col-sm-12">
                                        <div className="cutover-eula-header">Usage-Based Insurance Program</div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="cutover-eula-body">In connection with this policy and any future renewal, you and your drivers agree to participate in DriveEasy Pro, our usage-based insurance program. Our usage-based insurance program may offer you a personalized rate for you and your business upon renewal using data collected by the OBD device(s) we provide. </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="cutover-eula-body">You and your drivers will need to install the OBD device in the vehicles as instructed. If you leave the program for any reason, or if you discontinue coverage for a vehicle with an OBD device, you will be required to return the OBD device, adapters, and cabling to us by following instructions that we will email to you.</div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="cutover-eula-body cutover-eula-link"><a className="popup-link" href="https://media.geico.com/legal/mobile/eula_driveeasy.htm" target="_blank">Commercial End User License Agreement</a></div>
                                    </div>
                                </div>
                            </div>}
                            {loggedInUser.userRole !== UserRole.Agent && selectedOption === "maybeLater" && <div className="col-sm-12">
                                <div className="flexible-container cutover-not-sure-yet-container">
                                    <div className="col-sm-12">
                                        <div className="cutover-eula-header row">Not sure yet? No problem!</div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="cutover-eula-body row">If you change your mind at any time, give us a call <div className="cutover-phone-text"> (866) 509-9444</div>.</div>
                                    </div>
                                </div>
                            </div>}
                            {loggedInUser.userRole === UserRole.Agent && selectedOption !== "maybeLater" && <div className="col-sm-12" id="agent-alert">
                                <div className="alert" id="alert-agent">
                                    <div className="alert--agent">
                                        <span className="icon-help-center-agent"></span>
                                        <ul className="alert-list">
                                            <li className="alert-content">
                                                <div className="h4">Please advise the business owner:</div>
                                                <p>In connection with this policy and any future renewal, you and your drivers agree to participate in DriveEasy Pro, our usage-based insurance program. Our usage-based insurance program may offer you a personalized rate for you and your business upon renewal using data collected by the OBD device(s) we provide.</p>
                                                <p>You and your drivers will need to install the OBD device(s) in the vehicle(s) as instructed. If you leave the program for any reason, or if you discontinue coverage for a vehicle with an OBD device, you will be required to return the OBD device, adapters, and cabling to us by following instructions that we will email to you.</p>
                                                <a href="https://www.geico.com/driveeasypro/help-center/" target="_blank">Commercial End User License Agreement</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>}
                            {loggedInUser.userRole === UserRole.Agent && selectedOption === "maybeLater" && <div className="col-sm-12" id="agent-alert-maybe-later">
                                <div className="alert" id="alert-agent-maybe-later">
                                    <div className="alert--agent">
                                        <span className="icon-help-center-agent"></span>
                                        <ul className="alert-list">
                                            <li className="alert-content">
                                                <div className="h4">Please advise the business owner:</div>
                                                <p>If you change your mind at any time you can opt in by giving us a call <b><u>(866) 509-9444.</u></b></p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>}
                            <div className="col-sm-12">
                                <button className="cutover-button-agree" onClick={() => this.onClickAgree()}>{selectedOption === "maybeLater" ? "Continue Back To Policy" : "Agree And Continue"}</button>
                            </div>
                        </div>
                    </div >}
                {(!eligibleProgram || eligibleProgram.programCode !== "DriveEasyProOBD2") &&
                    <CutoverComingSoon />
                }
                <CutoverAddressCollection />
                <CutoverSuccess />
            </>
        )
    }
}

const mapStateToProps = (state: any, ownProps: any) => ({
    loggedInUser: state.loggedInUser,
    policy: state.dshs.policy,
    eligibleProgram: state.dshs.eligibleProgram,
});

export default connect(
    mapStateToProps,
    DashboardStore.actionCreators,
)(CutoverPage as any);